import apiHandler from "../core/apiHandler";

const pdfTypeApi = apiHandler('pdf-types');
export default pdfTypeApi;
